import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import dayjs from "dayjs";
import { Topbar } from "../../components/include/Topbar";
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import DeleteModal from "../../components/common/DeleteModal";
import { isRole, isRoleType } from "../../redux/selectors/authSelector";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";

const View_news = () => {
  const [data, setData] = useState({});
  const [openMenuIndex, setOpenMenuIndex] = useState(false);
  const [loader, setLoader] = useState(false);
  const menuRefs = useRef({});
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const [selectedImage, setSelectedImage] = useState("");
  const dispatch = useDispatch();
  const params = useParams();
  const [selectedId, setSelectedId] = useState(null);
  const [modalOpenDelete, setmodalOpenDelete] = useState(false);
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);
  const schoolId = localStorage.getItem("activeSchoolId");
  const mode = localStorage.getItem("mode");

  const toggleMenu = (index) => {
    setOpenMenuIndex(!openMenuIndex);
    // setOpenMenuIndex(true);
  };
  const handleDelete = (id) => {
    setLoader(true);
    Postdata(HttpService.news_delete, { id: id, school_id: schoolId }).then(
      (res) => {
        //  if (role === "admin") {
        //     if (mode === "view") {
        //       navigate(`admin-school/view/${schoolId}`, {
        //         state: { mainTab: "News Management" },
        //       });
        //     } else {
        //       navigate("navigation-dashboard", {
        //         state: { mainTab: "News Management"},
        //       });
        //     }
        //   } else {
        //     navigate("news-management");
        //   }
      }
    );
    setLoader(false);
  };

  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.news_show, {
      id: params.id,
      school_id: schoolId,
    }).then((res) => {
      if (res.status === 200) {
        setData(res.data);
        if (res.data.image) {
          setSelectedImage(res.data.image); // Set first image initially
        }
      } else {
        dispatch(message(res.message));
      }
    });
    setLoader(false);
  };

  useEffect(() => {
    fetchData();
  }, []);
  if (loader) {
    return <div>Loading....</div>;
  }
  return (
    <>
      <Topbar aerrow={true} />
      <div className="mx-auto p-4">
        {selectedImage && (
          <div className="mb-4">
            <img
              src={selectedImage}
              alt="Selected"
              className="w-full h-96 object-fill rounded-lg "
            />
          </div>
        )}
        <div className="bg-white rounded-xl p-4 relative flex justify-between text-gray-800   mx-auto">
          <div>
            <h3 className="text-md font-semibold mb-2">{data.title}</h3>
            <h3 className="text-sm text-gray-400 font-normal ">
              {dayjs(data.createdAt).format("DD MMM YYYY")}
            </h3>

            <div dangerouslySetInnerHTML={{ __html: data.description }} />
          </div>
          <div className="bg-white  ">
            <div className="absolute top-3 right-3">
              <button onClick={() => toggleMenu()}>
                <img
                  src={HiOutlineDotsVertical}
                  className="text-black-500 hover:text-black"
                />
              </button>

              {openMenuIndex && (
                <div
                  ref={(el) => (menuRefs.current = el)}
                  className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10"
                >
                  <button
                    className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                    onClick={() =>
                      navigate(`news-management/edit/${data._id}`, {
                        state: { type: "edit" },
                      })
                    }
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => {
                      setSelectedId(data._id);
                      setmodalOpenDelete(true);
                    }}
                    className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <DeleteModal
          title="Delete News"
          message="Are you sure you want to delete News?
It will erase all the data permanently."
          modalOpenDelete={modalOpenDelete}
          setmodalOpenDelete={setmodalOpenDelete}
          handleDelete={handleDelete} // Don't call it here
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          modalOpenDeleteSuccess={modalOpenDeleteSuccess}
          setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
          module={"News Management"}
          redirectPage={"News Management"}
          //   redirectUrl={"/news-management"}
          redirectUrl={
            mode === "view"
              ? `admin-school/view/${schoolId}`
              : role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin"
                ? "navigation-dashboard"
                : "news-management"
          }
          redirectState={
            role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin" ? { mainTab: "News Management" } : undefined
          }
        />
      </div>
    </>
  );
};

export default View_news;
